import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TerritoryView } from "./TerritoryView";
import { TerritoryViewStore } from "../../store/TerritoryViewStore";
import { useStore } from "../../../../hooks";

export const TerritoryViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/territory/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TerritoryViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TerritoryView territoryViewStore={store} />
      </PageLayout>
    </div>
  );
});
